export function SuccessIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="2.5 2.5 39 39"
      className={className}
    >
      <path
        d="M22 2.75C32.6129 2.75 41.25 11.3871 41.25 22C41.25 32.6129 32.6129 41.25 22 41.25C11.3871 41.25 2.75 32.6129 2.75 22C2.75 11.3871 11.3871 2.75 22 2.75ZM22 4.90234C12.572 4.90234 4.90234 12.572 4.90234 22C4.90234 31.428 12.572 39.0977 22 39.0977C31.428 39.0977 39.0977 31.428 39.0977 22C39.0977 12.572 31.428 4.90234 22 4.90234Z"
        fill="#809362"
        stroke="#809362"
        strokeWidth="0.5"
      />
      <path
        d="M30.5959 15.1707C31.02 14.8245 31.6443 14.847 32.0364 15.2458L32.1086 15.3279C32.448 15.7499 32.434 16.3735 32.0334 16.7673L32.0325 16.7664L19.8469 28.9529C19.706 29.0938 19.5293 29.1908 19.3372 29.2371V29.2742H19.0872C18.7999 29.2742 18.5269 29.1591 18.3264 28.9587L18.3254 28.9578L13.4905 24.0896L13.4895 24.0886C13.0753 23.6673 13.0728 22.987 13.4905 22.5691L13.4924 22.5671L13.5745 22.4949C13.9698 22.1775 14.5384 22.1759 14.9309 22.4958L15.012 22.5691V22.5701L19.0872 26.6697L30.5139 15.2449L30.5959 15.1707Z"
        fill="#809362"
        stroke="#809362"
        strokeWidth="0.5"
      />
    </svg>
  );
}
